import React from 'react';
import {
	StackCompat as Stack,
	TextCompat as Text,
	useTheme,
} from 'components/FluentUICompat';
import {getDashboardClassNames} from '../Common/BaseWorkBenchComponent';

type BedarfsWorkbenchSectionProps = {
	renderBedarfsWorkbenchLists: () => JSX.Element;
	t: (key: string) => string;
};

export const BedarfsWorkbenchSection: React.FC<
	BedarfsWorkbenchSectionProps
> = ({renderBedarfsWorkbenchLists, t}) => {
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	return (
		<>
			<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
				<Text className={classNames.WorkbenchHeaderText}>
					{t('BedarfsBaselineOverviewHeader')}
				</Text>
			</Stack>

			<Stack horizontal horizontalAlign='start'>
				<Stack horizontal styles={{root: {width: '100%'}}} grow={1}>
					{renderBedarfsWorkbenchLists()}
				</Stack>
			</Stack>
		</>
	);
};
